import React from 'react';
interface BenefitSectionProps {
  number: number;
  title: string;
  description: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  reverse?: boolean;
  imageLeft?: boolean;
}
export function BenefitSection({
  number,
  title,
  description,
  imageSrc,
  imageAlt,
  reverse = false,
  imageLeft = false
}: BenefitSectionProps) {
  return <div className="mb-12" data-id="element-2">
      <div className={reverse ? 'flex flex-col' : imageLeft ? 'flex flex-col md:flex-row-reverse md:gap-8 md:items-start' : 'flex flex-col md:flex-row md:gap-8 md:items-start'} data-id="element-3">
        {/* Text content */}
        <div className="flex-1" data-id="element-4">
          <h3 className="text-xl md:text-2xl font-bold text-[#10b981] mb-4 flex items-start gap-3" data-id="element-5">
            <span className="text-3xl font-extrabold opacity-80" data-id="element-6">
              {number}.
            </span>
            <span className="mt-1" data-id="element-7">{title}</span>
          </h3>
          <div className="text-gray-700 leading-relaxed md:text-[21px]" data-id="element-8">
            {description}
          </div>
        </div>

        {/* Image */}
        {imageSrc && <div className={reverse ? 'mt-6 rounded-lg overflow-hidden shadow-sm border border-gray-100' : 'mt-6 md:mt-0 md:flex-shrink-0 rounded-lg overflow-hidden shadow-sm border border-gray-100 md:max-w-[234px]'} data-id="element-9">
            <img src={imageSrc} alt={imageAlt || 'Benefit illustration'} className="w-full h-auto" data-id="element-10" />
          </div>}
      </div>
    </div>;
}